import React from 'react';
import type { AddBalanceCardProps } from './types';

export const AddBalanceCard: React.FC<AddBalanceCardProps> = ({ 
  onAddBalance,
  title = "Add new balance",
  description = "Create a new balance\naccount for your funds"
}) => {
  return (
    <div 
      className="group cursor-pointer transition-all duration-200 hover:bg-accent/20 border-2 border-dashed border-border rounded-lg p-5 h-[190px] flex flex-col items-center justify-center bg-muted/30"
      onClick={onAddBalance}
    >
      {/* Plus Icon in Circle */}
      <div className="bg-white rounded-full w-12 h-12 flex items-center justify-center mb-4 shadow-sm">
        <div className="text-2xl font-normal text-muted-foreground">+</div>
      </div>

      {/* Text Content */}
      <div className="text-center max-w-[180px]">
        <div className="text-sm font-medium text-foreground mb-1">{title}</div>
        <div className="text-xs text-muted-foreground whitespace-pre-wrap leading-relaxed">
          {description}
        </div>
      </div>
    </div>
  );
};
